import { render, staticRenderFns } from "./StartTest.vue?vue&type=template&id=b55fb3a6&scoped=true&"
import script from "./StartTest.vue?vue&type=script&lang=js&"
export * from "./StartTest.vue?vue&type=script&lang=js&"
import style0 from "./StartTest.vue?vue&type=style&index=0&id=b55fb3a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55fb3a6",
  null
  
)

export default component.exports